/** @jsx jsx */
import { jsx } from "theme-ui"
import styled from "styled-components"
import theme, { rem } from "@src/theme"

export const Block = ({ styles, children, fullFlex = null }) => {
  return (
    <BlockOuter
      bg={styles.bg}
      color={styles.color}
      fullFlex={fullFlex}
      height={styles.height}
      sx={{
        ...styles,
      }}
    >
      {children}
    </BlockOuter>
  )
}

export const ImageBlock = ({ styles, image, size = 'md' }) => {
  const height = {
    sm: [rem(250), null, "100%"],
    md: [rem(420), null, "100%"],
  }[size]

  const minHeight = {
    sm: [rem(250), null, rem(400)],
    md: [rem(360), null, rem(550)]
  }[size]

  return (
    <div>
      <div
        sx={{
          backgroundImage: `url(${image})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          height: height,
          minHeight: minHeight,
          ...styles
        }}
      ></div>
    </div>
  )
}

const TwoColumnSection = ({ col1, col2, styles = {}, ...props }) => (
  <Outer
    sx={{
      display: "flex",
      flexDirection: ["column", null, "row", null],
      ...styles,
    }}
    {...props}
  >
    {col1}
    {col2}
  </Outer>
)

const Outer = styled.section`
  > :first-child {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  > :nth-child(2) {
    flex: 1.8;
    display: flex;
  }
`
const BlockOuter = styled.div`
  &:last-child {
    flex: 1;
  }

  padding: ${0} 5vw ${0} 5vw;
  background: ${p => theme.colors[p.bg]};
  color: ${p => theme.colors[p.color]};
  width: 100%;
  height: ${p => p.height};
  ${p =>
    p.fullFlex &&
    `
  flex: 1;
  `}
`

export default TwoColumnSection
